import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Participant } from '../types';

export class AvatarHelper {
  static getParticipantAvatars = (participants: Participant[]) =>
    participants.map(participant => ({
      name: this.getDisplayName(participant),
      thumbUrl: participant.thumbUrl,
    }));

  static getDisplayName = (participant: Partial<Participant>, showDeactivated = true) => {
    if (!participant) {
      return;
    }
    const name =
      participant.fullName ||
      `${participant.firstName || ''} ${participant.lastName || ''}`.trim() ||
      participant.email?.trim();

    return participant.deletedAt && showDeactivated ? `${name} ${t('dr_deactivated')}` : name;
  };
}
